module.exports = __webpack_public_path__ + "img/3.0714631e.jpg";